import {
  LetterbookOrderOption,
} from "features/Letterbooks/types";
import {
  bookLength,
  bookPopularity,
  bookRating,
  bookReleaseDate,
  bookTitle,
  shuffle,
  yourLastDateRead,
  yourPercentage,
  yourRating,
} from "./orders";
import { FindOrderOptionsType } from "../findOrderOptions";
import { UserSerializersUserByline } from "types/serializers";
import useCurrentUser from "hooks/fragments/useCurrentUser";

const promptPosition: LetterbookOrderOption = {
  title: "Prompt Position",
  fieldname: "prompt_books_position",
  direction: "desc",
  type: "number",
};

const sortOptions = [
  bookTitle,
  bookPopularity,
  bookReleaseDate,
  bookLength,
  bookRating,
  shuffle,
] as LetterbookOrderOption[];

const LoggedInOptions = [
  yourRating,
  yourLastDateRead,
] as LetterbookOrderOption[];

function calculateCurrentUserOptions(currentUser: UserSerializersUserByline | null) {
  if (!currentUser?.id) {
    return [];
  }

  return LoggedInOptions.map((option) => {
    return {
      ...option,
      ...{ user: currentUser },
    };
  });
}

// Pro Options
const ProOptions = [yourPercentage] as LetterbookOrderOption[];
function calculateProOptions(currentUser: UserSerializersUserByline) {
  return ProOptions.map((option) => {
    return {
      ...option,
      ...{ user: currentUser, pro: true },
    };
  });
}

export default function promptOrderOptions(): FindOrderOptionsType {
  const currentUser = useCurrentUser();

  const currentUserOptions = calculateCurrentUserOptions(currentUser);
  const proOptions = calculateProOptions(currentUser);

  const orderOptions = [
    ...[promptPosition],
    ...sortOptions,
    ...currentUserOptions,
    ...proOptions,
  ].sort((a, b) => a.title.localeCompare(b.title));

  return {
    orderOptions: orderOptions.sort((a, b) => a.title.localeCompare(b.title)),
    order: promptPosition,
  };
}
